import { Outlet, createFileRoute } from '@tanstack/react-router';

import { Sidebar } from '@/common/components/features/sidebar';

const DashboardLayout = () => {
  return (
    <div className='flex w-full h-full'>
      <Sidebar />
      <Outlet />
    </div>
  );
};

export const Route = createFileRoute('/_app/_dashboard')({
  component: DashboardLayout,
});
